import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export default function CTASection() {
  return (
    <section className="relative bg-[#0b0b0d] py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-amber-500/25 via-transparent to-transparent" />
        <div className="absolute -bottom-40 left-1/2 -translate-x-1/2 h-[500px] w-[900px] rounded-full bg-amber-500/15 blur-3xl" />
      </div>
      <div className="absolute inset-0 bg-grid opacity-30" />

      <div className="relative max-w-4xl mx-auto px-6 lg:px-10 text-center">
        <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-amber-400 mb-6">
          — Get Started
        </div>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold text-white leading-[1.05]">
          Transform your welding experience
          <br />
          <span className="text-amber-400">today.</span>
        </h2>
        <p className="mt-6 text-white/70 text-lg max-w-2xl mx-auto">
          Join thousands of satisfied customers who trust Prakash Electrodes for their
          welding solutions. Get in touch for pricing, samples, or bulk orders.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <Link to="/contact">
            <Button
              size="lg"
              className="btn-primary bg-amber-500 hover:bg-amber-500 text-[#0b0b0d] font-semibold h-12 px-8 rounded-md"
            >
              Contact Sales <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
          <Link to="/products">
            <Button
              size="lg"
              variant="ghost"
              className="text-white hover:text-amber-400 hover:bg-white/5 h-12 px-6 rounded-md border border-white/15"
            >
              Browse Products
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
